<template>
  <v-container>
    <v-navigation-drawer
      color="primary"
      v-model="drawer"
      app
      clipped
      left
      style="top: 64px; max-height: calc(100% - 64px)"
    >
      <v-list dense dark v-if="!loading">
        <v-list-item-group v-model="model" mandatory color="indigo">
          <router-link
            class="white--text navigation-a-underline--remove"
            :to="{ name: 'brands' }"
            v-show="getMe.menu_access.groups.visible"
          >
            <v-list-item link>
              <v-list-item-action>
                <v-icon>mdi-account-multiple</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{
                  $t("components.navigationBar.managerBar.brands")
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link
            class="white--text navigation-a-underline--remove"
            :to="{ name: 'dealers' }"
            v-show="getMe.menu_access.dealers.visible"
          >
            <v-list-item link>
              <v-list-item-action>
                <v-icon>mdi-handshake</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{
                  $t("components.navigationBar.managerBar.partners")
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link
            class="white--text navigation-a-underline--remove"
            :to="{ name: 'serviceProviders' }"
            v-show="getMe.menu_access.service_providers.visible"
          >
            <v-list-item link>
              <v-list-item-action>
                <v-icon>mdi-tools</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title
                  >{{
                    $t("components.navigationBar.managerBar.servicePartners")
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link
            class="white--text navigation-a-underline--remove"
            :to="{ name: 'suppliers' }"
            v-if="false"
          >
            <v-list-item link>
              <v-list-item-action>
                <v-icon>mdi-package-variant</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{
                  $t("components.navigationBar.managerBar.suppliers")
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </v-list-item-group>
      </v-list>
      <template v-slot:append>
        <powered-by-sentinel :is-navbar="true" />
      </template>
    </v-navigation-drawer>
  </v-container>
</template>
<script>
// import TopBar from "./TopBar";
import { mapGetters, mapState } from "vuex";
import { USER_CRM_REQUEST } from "@/store/actions/user";
import PoweredBySentinel from "../banners/PoweredBySentinel.vue";

export default {
  name: "ManagerBar.vue",
  components: { PoweredBySentinel },
  data: () => ({
    drawer: null,
    loading: true,
    drawerStatus: [
      "/users/brands",
      "/users/dealers",
      "/users/providers",
      "/users/suppliers",
    ],
    model: null,
  }),
  mounted() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "COLLAPSED") {
        this.drawer = mutation.payload;
      }
    });
  },

  watch: {
    getMe(newValue) {
      if (
        typeof newValue === "undefined" ||
        Object.keys(newValue).length === 0
      ) {
        return;
      }
    },
    drawer(val) {
      if (this.getDrawerStatus !== this.drawer) {
        this.$store.commit("COLLAPSED", val);
      }
    },
  },
  created() {
    if (Object.keys(this.getMe).length === 0) {
      this.$store.dispatch(USER_CRM_REQUEST).then(() => {
        this.loading = false;
      });
    } else {
      this.loading = false;
    }

    this.drawerStatus.forEach((element, index) => {
      if (this.subMenuActive(element)) {
        this.model = index;
      }
    });
  },
  methods: {
    subMenuActive(input) {
      return [input].some((path) => {
        return this.$route.path.indexOf(path) === 0;
      });
    },
  },
  computed: {
    ...mapGetters(["getDrawerStatus", "getMe"]),
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";
.navigation-text-size--hover {
  font-size: 14px;
  &:hover {
    color: --primary;
  }
}
.navigation-icon--hover {
  &:hover {
    color: --primary;
  }
}
.navigation-a-underline--remove {
  text-decoration: none;
}
</style>
